<script lang="ts" module>
	import { type VariantProps, tv, cn } from 'tailwind-variants'

	export const badgeVariants = tv({
		base: 'rounded-full border border-transparent font-medium transition-colors focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50 inline-flex w-fit shrink-0 items-center justify-center overflow-hidden whitespace-nowrap transition-colors select-none',
		variants: {
			variant: {
				brand:
					'bg-background text-branding-blue-foreground border-branding-blue [a]:hover:bg-background/80',
				default: 'bg-primary text-primary-foreground [a]:hover:bg-primary/80',
				outline: 'border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground',
				secondary: 'bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80',
				warning: 'border-orange-400 bg-background text-orange-400 [a]:hover:bg-orange-400/10',
				ghost: 'hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50',
				link: 'text-primary underline-offset-4 hover:underline',
			},
			size: {
				'4xs': 'px-1 py-0.5 text-4xs',
				'3xs': 'px-1 py-0.5 text-3xs',
				'2xs': 'px-0.5 py-0.5 text-2xs',
				sm: 'px-2 py-0.5 text-sm',
			},
		},
	})

	export type BadgeVariant = VariantProps<typeof badgeVariants>['variant']
	export type BadgeSize = VariantProps<typeof badgeVariants>['size']
</script>

<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAnchorAttributes } from 'svelte/elements'

	let {
		ref = $bindable(null),
		href,
		class: className,
		variant,
		size,
		children,
		...restProps
	}: WithElementRef<HTMLAnchorAttributes> & {
		variant: BadgeVariant
		size: BadgeSize
	} = $props()
</script>

<svelte:element
	this={href ? 'a' : 'span'}
	bind:this={ref}
	class={cn(badgeVariants({ variant, size }), className)}
	data-slot="badge"
	{href}
	{...restProps}
>
	{@render children?.()}
</svelte:element>
